export default __webpack_public_path__ + "c650765fa2805957ec40245b56bc3935.svg";